/**
 * aiHelper — "粮小助" AI 客服 (MaxKB) 嵌入配置
 *
 * 正式形态: 启动时调后端 /hl-drying/drying/ai-helper/config/active 拿激活配置
 *   (TBL_DRYING_AI_HELPER_CONFIG 表存多套: local/tunnel/test/prod, 切环境改表前端零改动)。
 * 兜底形态: 后端接口不可用/无激活行时 (如本地演示、后端未发版), 用下面的本地默认。
 * iframe 地址拼法: {baseUrl}/chat/{chatToken}?mode=mobile (MaxKB 移动端布局, 适合抽屉窄容器)。
 */

// 本地兜底配置 (与库表 local 行一致: 本机 Docker MaxKB)
export const AI_HELPER_FALLBACK = {
  configKey: 'local',
  configName: '本地环境(兜底)',
  baseUrl: 'http://127.0.0.1:8088',
  chatToken: '18d681ce9a31d34f'
}

// 总开关: 临时下线 AI 助手时改 false (后端无激活配置且这里也关 = 完全隐藏小球)
export const AI_HELPER_ENABLED = true

/**
 * 由配置拼 iframe 地址.
 * @param {Object} cfg { baseUrl, chatToken }
 * @param {Object} [opts] { mobile: boolean } 默认 true(抽屉用移动端布局)
 */
export function buildChatUrl(cfg, opts) {
  const mobile = !opts || opts.mobile !== false
  const base = String(cfg.baseUrl || '').replace(/\/+$/, '')
  return `${base}/chat/${cfg.chatToken}${mobile ? '?mode=mobile' : ''}`
}
